/** Ruta system_menu (sin slash). Authz UI = menú asignado. */
export const MENU_LISTA_NEGRA = "cheques_lista_negra";

export const TAB_ACTIVOS = "activos";
export const TAB_HISTORICOS = "historicos";

export const LABEL_MOTIVO_RECHAZO = {
  sin_fondos: "Sin fondos",
  cuenta_cerrada: "Cuenta cerrada",
  orden_no_pagar: "Orden de no pagar",
  defecto_formal: "Defecto formal",
  endoso_invalido: "Endoso inválido",
  cheque_vencido: "Cheque vencido",
  firmante_no_autorizado: "Firmante no autorizado",
  otro: "Otro",
};

export const labelMotivoRechazo = (valor) => {
  if (valor == null || valor === "") return "—";
  if (typeof valor === "object") {
    return (
      valor.motivo ||
      LABEL_MOTIVO_RECHAZO[valor.codigo] ||
      (valor.codigo != null ? String(valor.codigo) : "—")
    );
  }
  return LABEL_MOTIVO_RECHAZO[valor] || String(valor);
};

export const LABEL_TIPO_EVENTO = {
  alta: "Alta en lista negra",
  re_alta: "Re-alta",
  liberacion: "Liberación",
};

export const labelTipoEvento = (tipo) =>
  LABEL_TIPO_EVENTO[tipo] || tipo || "—";

export const normalizarCuit = (cuit) =>
  String(cuit || "").replace(/\D/g, "");

export const rutaListaNegra = () => `/${MENU_LISTA_NEGRA}`;
